import { Injectable, NgZone } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ModalController,Platform } from "@ionic/angular";

// maybe re-map the following

import { env } from "../../environments/environment";
import { AppConst } from "./consts/AppConsts";


@Injectable()
export class CombeniaSyncService {
  private deviceId: String = "iOS:AAA-xxx-xxx-xxx";
  public platform_ready: boolean = false;

  constructor(
    private http: HttpClient, 
    public modalCtrl: ModalController,    
    private platform: Platform
  ) {
    this.platform.ready().then(() => {
      this.platform_ready = true;
    });
  }


  public getCompleteDeviceId(){
    return `web:${this.getDeviceId()}`;
  }

  public getDeviceId() {
    let uuid = localStorage.getItem(AppConst.UUID);
    if (uuid) {
      return uuid;
    }
    else {
      let uuid = (new Date().getTime().toString(16)) + '-' + this.s4() + this.s4() + this.s4() + this.s4();
      localStorage.setItem(AppConst.UUID, uuid);
      return uuid;
    }
  }
  private s4(): string {
    var str = Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    return str;
  };

  saveUserCredentials(username: string, password: string, loginResponse: any) {
    localStorage.setItem(AppConst.USER_CREDENTIALS, JSON.stringify({
      username: username,
      password: password,
      loginResponse: loginResponse
    }));
  }
  getUserCredentials() {
    const userConfig: string = localStorage.getItem(AppConst.USER_CREDENTIALS);
    const userCred: any = (userConfig) ? JSON.parse(userConfig) : { username: '', password: '' };
    return userCred;
  }

  logout(){
    localStorage.removeItem(AppConst.USER_CREDENTIALS);
    
  }

  isAuthenticated():boolean{
      let userCred= this.getUserCredentials();
      return userCred.username && userCred.loginResponse && userCred.loginResponse.token;
  }

  getToken():string{
    if(!this.isAuthenticated)
      return null;
    
    return this.getUserCredentials().loginResponse.token;
  }

  getTokenUrlEncoded() : string{
    if(!this.isAuthenticated)
      return null;
    
    return this.getUserCredentials().loginResponse.tokenUrlEncoded;
  }


  login(username: string, password: string) {
    this.deviceId = this.getCompleteDeviceId();
    let _logPrefix: string = "[CombeniaSyncService.login]";

    return new Promise((resolve, reject) => {
      let login = this.http
        .get(
          env.baseUrl +
            `/authorize.app?username=${username}&password=${password}&tenant=${
              env.tenant
            }&deviceId=${this.deviceId}`
        )
        .subscribe(
          success => {
            console.log(_logPrefix, success);
            this.saveUserCredentials(username, password, success);
            resolve(success);
          },
          error => {
            console.error(_logPrefix, error);
            reject(error);
          },
          () => {
            login.unsubscribe();
          }
        );
    });
  }




}
